/* hs-eslint ignored failing-rules */

/* eslint-disable @typescript-eslint/no-floating-promises */

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { fetchBusinessObjectives } from '../actions/BusinessObjectiveActions';
import { PENDING } from '../actions/constants/RequestStatus';
import { useAppDispatch } from '../reducers';
import { businessObjectivesForHighlightedProductsSelector, fetchBusinessObjectiveStatus } from '../selectors/BusinessObjectiveSelectors';
export const useBusinessObjectives = ({
  highlightedProducts
}) => {
  const dispatch = useAppDispatch();
  const passedInBusinessObjectives = useSelector(state => {
    return businessObjectivesForHighlightedProductsSelector(state, {
      highlightedProducts
    });
  });
  const requestStatus = useSelector(fetchBusinessObjectiveStatus);
  useEffect(() => {
    if (!highlightedProducts.length || requestStatus === PENDING) {
      return;
    }

    const productsToFetch = highlightedProducts.filter(apiName => {
      return !passedInBusinessObjectives[apiName] && getProductLevelFromApiNameString(apiName) !== FREE;
    });

    if (productsToFetch.length) {
      dispatch(fetchBusinessObjectives({
        highlightedProducts: productsToFetch
      }));
    }
  }, [highlightedProducts]);
};